import React from 'react';
import { ChangeEmailStep as ChangeEmailStepForm } from '@fiverr-private/code_activation';
import { useIdentificationContext } from '@fiverr-private/identification_core';
import { useStepsContext } from '../../StepsContext';
import { globalBigQueryReporter, globalMixpanelReporter } from '../../../events';

export const ChangeEmailStep = () => {
    const { goToStep } = useStepsContext();
    const { email, setEmail } = useIdentificationContext();

    const handleEmailChange = (email: string) => {
        setEmail(email);
        goToStep('code_activation');
    };

    return (
        <ChangeEmailStepForm
            email={email}
            onEmailChanged={handleEmailChange}
            mixpanelEnrichment={globalMixpanelReporter.enrichment as Record<string, string>}
            bigQueryEnrichment={globalBigQueryReporter.enrichment as Record<string, string>}
        />
    );
};
